interface TransformationIndicatorProps {
  state: 'idle' | 'processing' | 'success';
}

const stateLabels = {
  idle: 'Ready to convert PDF to Google Sheets',
  processing: 'Converting PDF to Google Sheets',
  success: 'PDF converted to Google Sheets',
};

export default function TransformationIndicator({ state }: TransformationIndicatorProps) {
  // Success state: only show Sheets icon with checkmark badge
  if (state === 'success') {
    return (
      <div
        className="flex items-center justify-center mb-4 py-2"
        role="status"
        aria-label={stateLabels[state]}
      >
        <div className="relative">
          {/* Sheets Icon */}
          <div className="w-24 h-24 flex items-center justify-center drop-shadow-lg">
            <img src="/PDF_file_icon 2.svg" alt="" className="w-24 h-24" aria-hidden="true" />
          </div>
          {/* Checkmark badge */}
          <div className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-emerald-500 flex items-center justify-center shadow-lg shadow-emerald-500/30 border-2 border-white">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
      </div>
    );
  }

  // Idle and processing states: show PDF → arrow → Sheets
  return (
    <div
      className="flex items-center justify-center md:gap-4 gap-2 md:mb-4 mb-2 py-2"
      role="status"
      aria-label={stateLabels[state]}
    >
      {/* PDF Icon */}
      <div className="w-20 h-20 flex items-center justify-center drop-shadow-md">
        <img src="/PDF_file_icon 1.svg" alt="" className="w-20 h-20" aria-hidden="true" />
      </div>

      {/* Arrow */}
      <div className="w-12 flex items-center justify-center">
        {state === 'idle' && (
          <svg className="w-10 h-6 text-gray-400" viewBox="0 0 40 24" fill="none" aria-hidden="true">
            <path
              d="M4 12h32M36 12l-7-7M36 12l-7 7"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {state === 'processing' && (
          <svg className="w-10 h-6 text-emerald-500 animate-arrow-pulse" viewBox="0 0 40 24" fill="none" aria-hidden="true">
            <path
              d="M4 12h32M36 12l-7-7M36 12l-7 7"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>

      {/* Sheets Icon */}
      <div className="w-20 h-20 flex items-center justify-center drop-shadow-md">
        <img src="/PDF_file_icon 2.svg" alt="" className="w-20 h-20" aria-hidden="true" />
      </div>

      {/* CSS Animation for arrow */}
      <style>{`
        @keyframes arrow-pulse {
          0%, 100% { opacity: 1; transform: translateX(0); }
          50% { opacity: 0.6; transform: translateX(4px); }
        }
        .animate-arrow-pulse {
          animation: arrow-pulse 1s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
